import { cnpj } from 'cpf-cnpj-validator';
import { StringSchema } from 'yup';

export default function (this: StringSchema, message: string) {
  return this.test('cnpj', message, (value = '') => cnpj.isValid(value));
}
